












import { contains } from "@service/helpers/domHelper";
import { Vue, Component } from "vue-property-decorator";

import EventTypeSelectPanel from "./EventTypeSelectPanel.vue";

@Component({ components: { EventTypeSelectPanel } })

export default class EventTypeSelectButton extends Vue {
    showEventTypeSelect = false;

    mounted() {
        document.addEventListener('click', this.documentClickHandler)
    }

    destroyed() {
        document.removeEventListener('click', this.documentClickHandler)
    }

    documentClickHandler(event: Event) {
        const target = event.target as HTMLElement;
        const eventTypeSelectEl = (this.$refs.eventTypeSelect as Vue)?.$el as HTMLElement;
        const addTypeSelectButton = this.$refs.eventTypeSelectButton as HTMLElement | null;

        if(!contains(eventTypeSelectEl, target) && !contains(addTypeSelectButton, target)) {
            this.showEventTypeSelect = false;
        }
    }
}

